<template>
    <div class="copyright">
        <div class="pw fix">
            <div class="footerNav">
                <template v-for="(item,i) in navList">
                    <a href="javascript:;" v-if="showWater" :key="i">{{item.name}}</a>
                    <a :href="item.url" :key="i" target="_blank" v-else>{{item.name}}</a>
                </template>
            </div>
            <div class="copyBox">
                <div class="copy_left">
                    <p>Copyright Reserved 2000-{{timer}} 雅昌艺术网 版权所有 
                    
                        <a
                                style="    margin-left: 20px;"
                                href="https://m-auction.artron.net/artLicence"
                                target="_blank"
                            >
                                证照信息
                            </a></p>
                    <p><a :href="showWater ? 'javascript:;':'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302000792'" target="_blank">京公网安备 11011302000792号</a><a :href="showWater ? 'javascript:;':'https://www.miibeian.gov.cn'" target="_blank">粤ICP备17056390号-4</a><a :href="showWater ? 'javascript:;': 'https://www.artron.net/about_us/vz_artron.php'" target="_blank">信息网络传播视听节目许可证1909402号</a></p>
                    <p><span>增值电信业务经营许可证（粤）B2-20030053</span><span>广播电视制作经营许可证（粤）字第717号企业</span><span>网络文化经营许可证粤网文（2021）1750-217号</span> <span>{{ ua }}</span></p>

                </div>
                <div class="copy_right">
                    <el-popover placement="left-start" trigger="hover" :popper-append-to-body="false">
                        <a href="javascript:;" slot="reference"  class="account icon_wb">微博</a>
                        <div class="img-hover">
                            <img
                                src="../../assets/imgs/weixin.png"
                                alt=""
                            />
                        </div>
                    </el-popover>
                    <el-popover placement="left-start" trigger="hover" :popper-append-to-body="false">
                        <a  slot="reference" href="javascript:;"  class="account icon_wx">公众号</a>
                        <div class="img-hover">
                            <img
                                src="../../assets/imgs/weibo.png"
                                alt=""
                            />
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "copyright",
    props:['showWater'],
    data(){
        return{
            ua:'',
            navList:[{
                name:'关于我们',
                url:'https://www.artron.net/aboutus/aboutus'
            },{
                name:'产品介绍',
                url:'https://minisite.artron.net/product/'
            },{
                name:'人才招聘',
                url:'https://job.artron.net'
            },{
                name:'雅昌动态',
                url:'https://news.artron.net/morenews.php?column_id=119'
            },{
                name:'联系我们',
                url:'https://minisite.artron.net/contact/'
            },{
                name:'网站地图',
                url:'https://www.artron.net/map'
            },{
                name:'版权说明',
                url:'https://www.artron.net/aboutus/copyright'
            },{
                name:'免责声明',
                url:'https://www.artron.net/aboutus/mzsm'
            },{
                name:'隐私权保护',
                url:'https://www.artron.net/aboutus/privacy'
            },{
                name:'友情链接',
                url:'https://www.artron.net/aboutus/link'
            },{
                name:'雅昌集团',
                url:'https://www.artron.com.cn'
            },{
                name:'专家顾问',
                url:'https://www.artron.net/aboutus/adviser'
            },{
                name:'法律顾问',
                url:'https://www.artron.net/aboutus/law'
            }]
        }
    },
     
    mounted() {
        this.ua = navigator.userAgent;
    },
    computed:{
        timer(){
            let timr = new Date()
            return timr.getFullYear()
        }
    }
}
</script>

<style scoped lang="scss">
.copyright{background-color: #333333;margin-top: 80px;}
.footerNav{display:flex;padding:40px 0;justify-content: space-between;
    a{color:#fff;font-size: 14px;line-height: 22px;}
}
.copyBox{display:flex;justify-content: space-between;padding-bottom: 38px;
    .copy_left{color:#8C8C8C;line-height: 18px;font-size: 12px;
        p{margin-bottom: 10px;}
        a{color:#8C8C8C;}
        a,span{margin-right: 20px;}
        a:hover{color:#0F820C;}
    }
    .copy_right{font-size: 0;
        a{padding-top: 51px;line-height: 20px;font-size: 12px;color:#8c8c8c;background-repeat:no-repeat;display:inline-block;width:48px;text-align: center;margin-left: 28px;margin-top: 5px;position: relative;}
        a:after{background-color: #737373;width:46px;height:46px;margin:0 auto;content:'';background-repeat: no-repeat;background-position: center;position: absolute;top:0;left:0;border-radius: 50%;}
        .icon_wx:after{background-image: url("../../assets/imgs/icon_wx.png");}
        .icon_wb:after{background-image: url("../../assets/imgs/icon_wb.png");}

    }

}
/deep/.el-popper {
    width: 120px !important;
    height: 120px !important;
    padding: 0px;
}
.img-hover {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 100px;
        height: 100px;
    }
}
/deep/.el-popover {
    min-width: 120px;
}
</style>